// import {DragDropModule} from '@angular/cdk/drag-drop';
// import {ScrollingModule} from '@angular/cdk/scrolling';
// import {CdkTableModule} from '@angular/cdk/table';
// import {CdkTreeModule} from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
// import { InputfieldModule } from "./components/inputfield/inputfield.module";
// import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {
  MatDateFnsModule,
  MAT_DATE_FNS_FORMATS
} from '@angular/material-date-fns-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrModule } from 'ngx-toastr';
// import { GoogleMapService } from '../services/google/google.map.service';
// import { MatGoogleMapsAutocompleteModule } from './ google-maps-autocomplete/mat-google-maps-autocomplete.module';
import { CheckBoxComponent } from './components/checkBox/checkbox.component';
import { DaterangeComponent } from "./components/daterange/daterange.component";
import { FooterComponent } from './components/footer/footer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalModule } from './components/modal/modal.module';
import { SearchComponent } from './components/search/search.component';
// import { TableModule } from './components/table/table.module';
import { WhitebuttonModule } from './components/whitebutton/whitebutton.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

// import { McPaginatorDirective } from "./directives/mcpaginator.directive";




@NgModule({
  declarations: [LoadingComponent, FooterComponent, SearchComponent, CheckBoxComponent, DaterangeComponent
    // , McPaginatorDirective
  ],
  imports: [
    CommonModule,
    WhitebuttonModule,
    // TableModule,
    ModalModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    ReactiveFormsModule,
    MatTooltipModule,
    ToastrModule.forRoot(),
    // MatGoogleMapsAutocompleteModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatDateFnsModule,
  ],
  exports: [
    // McPaginatorDirective,
    DaterangeComponent,
    CheckBoxComponent,
    // MatGoogleMapsAutocompleteModule,
    LoadingComponent,
    FooterComponent,
    SearchComponent,
    MatFormFieldModule,
    WhitebuttonModule,
    // TableModule,
    ModalModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatListModule,
    ToastrModule,
    MatDateFnsModule,
  ],
  providers: [{ provide: MAT_DATE_FNS_FORMATS, useValue: { useUtc: true } }],
})
export class SharedModule {
  // constructor(googleMapService: GoogleMapService) {
  //   googleMapService.isGoogleMapsLoaded().subscribe((res) => {
  //     console.log(res);
  //   });
  // }
}
